import { config_settings } from '@/config.js';
import Vue from 'vue';

export const getVisaAuth = (configData) => {
  return Vue.$http({
    method: 'post',
    url: config_settings.PROD_ENV
      ? configData.ecommerceProps.paymentMethods.niubiz.cdnProdWebMode.authServer
      : configData.ecommerceProps.paymentMethods.niubiz.cdnTestWebMode.authServer,
    auth: {
      username: config_settings.PROD_ENV
        ? configData.ecommerceProps.paymentMethods.niubiz.cdnProdWebMode.username
        : configData.ecommerceProps.paymentMethods.niubiz.cdnTestWebMode.username,
      password: config_settings.PROD_ENV
        ? configData.ecommerceProps.paymentMethods.niubiz.cdnProdWebMode.password
        : configData.ecommerceProps.paymentMethods.niubiz.cdnTestWebMode.password,
    },
  });
};

export const getVisaSessionId = (jsonObject, niubizSessionKey, configData) => {
  return Vue.$http({
    method: 'post',
    url: config_settings.PROD_ENV
      ? configData.ecommerceProps.paymentMethods.niubiz.cdnProdWebMode.resourceServer +
        '/' +
        configData.ecommerceProps.paymentMethods.niubiz.cdnProdWebMode.merchantId
      : configData.ecommerceProps.paymentMethods.niubiz.cdnTestWebMode.resourceServer +
        '/' +
        configData.ecommerceProps.paymentMethods.niubiz.cdnTestWebMode.merchantId,
    data: jsonObject,
    headers: {
      Authorization: niubizSessionKey,
    },
  });
};
